// Même logique que le badge d'urgence de la maquette Bureau : dérivée
// uniquement de la date d'échéance (pas de champ "late" séparé), comme
// ToDo.js le fait déjà via isPast/parseISO. Le rendu (couleurs exactes de
// la maquette) vit directement dans FeedItemRow.js.
export function urgencyOf(due) {
  if (!due) return { tone: "neutral", label: "—" };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(due);
  target.setHours(0, 0, 0, 0);
  const days = Math.round((target - today) / 86400000);
  if (days < 0) return { tone: "bad", label: "En retard" };
  if (days === 0) return { tone: "bad", label: "Aujourd'hui" };
  if (days <= 2) return { tone: "warn", label: days === 1 ? "Sous 24 h" : `Sous ${days} j` };
  return { tone: "ok", label: `Dans ${days} j` };
}
